export default __webpack_public_path__ + "static/og-image-275489f558220fab42d06823b5a71785.png";